import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { claimFormStore } from '@client/routes/~console.$orgId/~claims/~details.$id/store';
import { trpc } from '@client/trpc/client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Library',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { data } = trpc.excess.getExcess.useQuery({
        id: Route.useParams().excessId,
    });
    // CUR-725: a closed claim's financial libraries are read-only (the server rejects the writes).
    const isReadonly = claimFormStore.use.isReadonly();

    return (
        <PageController route={Route}>
            <DocumentLibrary
                entity="excess"
                entityId={Route.useParams().excessId}
                showDownloadAllButton
                disableUploading={data?.isDismissed || isReadonly}
                readOnly={isReadonly}
            />
        </PageController>
    );
}
